<template>
    <section class="registration" style="background-image: url(img/city-bg.jpg)">
        <div class="container">
            <div class="form-block-inner">
                <form action="#" method="post" class="form join-form" id='join-form'>
                    <div class="requared">* Required</div>
                    <DetailsForm
                        :page_type="`register`"
                        :input_countries="countries"
                        :input_states="states"
                    >
                    </DetailsForm>
                </form>
            </div>
        </div>

        <RegisterTermsModal></RegisterTermsModal>
        <RegisterConfirmModal></RegisterConfirmModal>
    </section>
</template>

<script>
    import RegisterTermsModal from "./RegisterTermsModal";
    import RegisterConfirmModal from "./RegisterConfirmModal";
    import DetailsForm from "../Common/DetailsForm";

    export default {
        name: "RegisterForm",
        components: {
            RegisterTermsModal,
            RegisterConfirmModal,
            DetailsForm
        },
        props: {
            countries: {
                type: Array,
                required: true
            },
            states: {
                type: Array,
                required: true
            },
        }
    }
</script>
